import { useEffect, useState } from 'react';
import { Link, useSearchParams } from 'react-router-dom';
import { readMe, signOut, type SignedInUser } from '../api';
import { TournamentsPanel } from './TournamentsPanel';

const SIGN_IN_ERRORS: Record<string, string> = {
  config: 'Google sign-in is not configured.',
  unavailable: 'Sign-in is unavailable right now.',
  signin: 'Google sign-in did not finish. Try again.',
};

export function AdminPage() {
  const [params] = useSearchParams();
  const [me, setMe] = useState<SignedInUser | null>(null);
  const [notice, setNotice] = useState('');
  const signInError = SIGN_IN_ERRORS[params.get('error') ?? ''] ?? '';

  useEffect(() => {
    let cancelled = false;
    readMe()
      .then((user) => {
        if (!cancelled) setMe(user);
      })
      .catch(() => {
        if (!cancelled) setMe(null);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  async function logout(): Promise<void> {
    const ok = await signOut();
    if (!ok) {
      setNotice('Sign out was rejected.');
      return;
    }
    setMe(null);
  }

  if (me) {
    return (
      <main className="page page-wide">
        <h1>Admin</h1>
        <p>
          {me.name} ({me.email}) is signed in as {me.role === 'admin' ? 'Admin' : 'Staff'}.
        </p>
        <p className="actions">
          <Link to="/admin/people">People</Link>
          <button className="button" type="button" onClick={() => void logout()}>
            Sign out
          </button>
        </p>
        {notice ? <p className="note">{notice}</p> : null}
        <TournamentsPanel role={me.role} />
      </main>
    );
  }

  return (
    <main className="page">
      <h1>Admin</h1>
      <p>Sign in with the Google account an Admin has allow-listed.</p>
      {signInError ? <p className="note">{signInError}</p> : null}
      <p>
        <a className="button" href="/api/auth/google">
          Sign in with Google
        </a>
      </p>
      <p>
        <Link to="/">Mat Monitor home</Link>
      </p>
    </main>
  );
}
